module.exports = __webpack_public_path__ + "img/locked-arrow.91596e50.svg";